<script>
    import Price from '/srv/web/wyvr/html/releases/58819/gen/client/shop/product/Price.svelte?1733898724687';
    import Tax from '/srv/web/wyvr/html/releases/58819/gen/client/shop/product/Tax.svelte?1733898724687';
    import AddToCart from '/srv/web/wyvr/html/releases/58819/gen/client/shop/product/AddToCart.svelte?1733898724687';
    import { get_price_request } from '/srv/web/wyvr/html/releases/58819/gen/client/price_request/get_price_request.js?1733898724687';
    import Button from '/srv/web/wyvr/html/releases/58819/gen/client/price_request/Button.svelte?1733898724687';
    import { get_stock } from '/srv/web/wyvr/html/releases/58819/gen/client/shop/core/product/get_stock.js?1733898724687';
    import Live from '/srv/web/wyvr/html/releases/58819/gen/client/magento2/product/live/Live.svelte?1733898724687';

    wyvr: {
        render: 'hydrate';
        loading: 'instant';
    }

    export let product;
    export let locale = null;
    export let currency = null;

    $: price_request = get_price_request(product);

    function getInStock(product) {
        return get_stock(product)?.is_in_stock || false;
    }
</script>

<Live {product} let:product>
    {#if product}
        <div class="c-product-floating-cart">
            <div class="c-product-floating-cart__container">
                <div class="m-product-price">
                    {#if !price_request}
                        <Price {product} {locale} {currency} />
                        <Tax />
                    {/if}
                </div>
                <div class="product-stock product-stock--sku-242210003">
                    <div>
                        <div class="c-add-to-cart__wrapper">
                            {#if price_request && getInStock(product)}
                                <div class="c-product-price-request">
                                    <div>
                                        <div>
                                            <div
                                                class="c-product-price-request__button"
                                            >
                                                <Button {product} />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            {:else}
                                <div
                                    class="c-add-to-cart c-add-to-cart--purchase-able c-add-to-cart--in-cart"
                                >
                                    <AddToCart {product} />
                                </div>
                            {/if}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    {/if}
</Live>


<style>
    .c-product-floating-cart :global(.m-product-price__info) {
        text-align: right;
    }
    .c-add-to-cart {
        width: 100%;
    }
    :global(footer) {
        padding-bottom: 70px;
    }

    .c-product-floating-cart :global(.new-price) {
        display: flex;
        align-items: center;
    }

    .c-product-floating-cart :global(.price--percentage) {
        display: block !important;
        position: static;
        transform: none;
        margin-left: 0.5rem;
        font-size: var(--font-size__xs);
        font-weight: bold;
        color: var(--red);
        padding: 0.1rem 0.35rem;
        border-radius: 2rem;
        border: 1px solid var(--red);

        @media (min-width: 768px) {
            font-size: var(--font-size__s);
            padding: 0.1rem 0.5rem;
        }
    }
</style>